import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import RequestsTableService from '@/modules/requests/requestsTables/RequestsTableService';
var requestTable = {
  table: '',
  new_table: '',
  user: '',
  type: 'Local',
  all_discounted: false,
  client: '',
  status: '',
  command: '',
  discount: {
    value: 0,
    type: ''
  },
  serial: '',
  invalidated_by: '',
  from_client: '',
  products: [],
  pay_gateway: ''
};

var RequestsTableModel =
/** @class */
function (_super) {
  __extends(RequestsTableModel, _super);

  function RequestsTableModel() {
    var _this = _super.call(this, requestTable, RequestsTableService) || this;

    _this.modelName = 'Orden';
    return _this;
  }

  return RequestsTableModel;
}(BaseModel);

export default RequestsTableModel;